const targetElement = $("ul.news-content-list");

// 重複実行を避けるためのフラグ。イベント待機時にtrue
let lazyLoadFlag = true;


/**
 * Lazy Loadのメイン処理
 * スクロール時に使用されることを想定
 */
 function lazyLoad(){
    const loadUrl = $("#loadUrl").val() ? String($("#loadUrl").val()) : null;
    const tagId = $("#tagId").val() ? String($("#tagId").val()) : null;
    const keyword = $("#keyword").val() ? String($("#keyword").val()) : null;

    $.ajax({
        type: "GET",
        url: loadUrl,
        contentType: "application/json; charset=utf-8",
        data: {
            tagId: tagId,
            keyword: keyword,
            contentNo: targetElement.children("li").length,
        },
        dataType: "html",
        success: function (res) {
            // html反映
            targetElement.append(res);

            // 対象のコンテンツを全てレンダリングしたらスクロールイベント削除
            const isLoadEnd = $("#isLoadEnd").val() === "true" ? true : false;
            if (isLoadEnd) {
                $(window).off("lazyLoad");
            }
            lazyLoadFlag = true;
        },
        error: function (req, status, error) {
            // TODO: エラーメッセージは一旦決め打ちで入力
            const errorShow = `<p class="not-found-content__text black align-left">An error occurred in the search process.</p>`;
            targetElement.append(errorShow);
            $(window).off("lazyLoad");
        },
    });
}

/**
 * 検索機能
 * ページ遷移して検索実行する
 * @param {Event} e - イベント
 */
function searchNews(e){
    const searchUrl = String($("#searchUrl").val());
    const inputKeyword = String($("#inputKeyword").val());
    if(inputKeyword.length > 0){
        const urlParam = new URLSearchParams({
            inputKeyword: inputKeyword,
        });
        location.href = searchUrl + "/?" + urlParam;
    }
}

module.exports = {
    lazyLoad: function() {
        // LazyLoad用イベント
        $(window).on("load", function () {
            // LazyLoad後に画面更新・別画面から戻った場合に強制スクロールしてしまうためスクロール履歴削除
            history.scrollRestoration = "manual";
            $(window).scrollTop(0);
        });

        /**
         * lazyLoad（ページ最下までスクロールすると続きのデータを読み込む）
         */
        $(window).on('lazyLoad', function(){
            // ターゲット要素の底までスクロールしたか判定
            if ($(this).scrollTop() + $(this).height() > targetElement.offset().top + targetElement.height()) {
                if(lazyLoadFlag){
                    lazyLoadFlag = false;
                    lazyLoad();
                }
            }
        });

        // lazyLoadイベント発火用のスクロールイベント
        $(window).scroll(function(){
            $(window).trigger('lazyLoad');
        });
    },
    search: function() {
        // 検索用イベント
        $("input.input__search").blur(searchNews);
        $("input.input__search").keypress(function(e) {
            if (e.which == 13) {
                searchNews(e);
                return false;
            }
        });
    }
}
